/**
 * Styles partagés pour les composants React Hook Form réutilisables.
 * Ces styles sont indépendants de tout contexte métier.
 */
import styled from '@emotion/styled';
import { RadioGroup } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const FieldErrorText = styled.span<{ theme: ICustomTheme }>`
  color: ${({ theme }) => theme.colors.error.main};
  font-size: 0.75rem;
  display: block;
  margin-top: 4px;
`;

export const InputContainer = styled.div`
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const PlaceholderText = styled.span<{ theme: ICustomTheme }>`
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const StyledSelect = styled.div<{ theme: ICustomTheme }>`
  font-size: 16px;
  .MuiSelect-outlined {
    padding: 10.5px 14px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`;

// --- RHFCivilityField styles ---

export const CivilityFieldWrapper = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)}px;
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;

  /* FormLabel MUI est block par défaut, on le remet inline-flex */
  .MuiFormLabel-root {
    display: inline-flex;
    align-items: center;
    margin-bottom: 0;
  }
`;

export const RadioGroupInline = styled(RadioGroup)`
  margin-left: 24px;
`;

export const FormLabelStyled = styled.span<{ theme: ICustomTheme }>`
  font-size: ${({ theme }) => theme.fontSizes.desktopLabel}px;
  color: ${({ theme }) => theme.colors.black.main};
  margin-right: ${({ theme }) => theme.spacing(1)}px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: ${({ theme }) => theme.fontSizes.mobileLabel}px;
  }
`;

export const RadioLabelStyled = styled.span<{ theme: ICustomTheme }>`
  font-size: ${({ theme }) => theme.fontSizes.desktopLabel}px;
  color: ${({ theme }) => theme.palette.text.secondary};
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: ${({ theme }) => theme.fontSizes.mobileLabel}px;
  }
`;
